"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bulkDeleteRecipesMutationOptions = exports.bulkDeleteRecipesMutation = void 0;
const client_1 = require("@apollo/client");
const meUser_1 = require("../../user/fragments/meUser");
exports.bulkDeleteRecipesMutation = client_1.gql `
  mutation BulkDeleteRecipes($recipeIds: [String!]!) {
    bulkDeleteRecipes(recipeIds: $recipeIds) {
      __typename
      ok
      user {
        ...meUser
      }
    }
  }
  ${meUser_1.meUserFragment}
`;
exports.bulkDeleteRecipesMutationOptions = (variables) => ({
    variables,
    update: cache => {
        variables.recipeIds.forEach(id => {
            cache.evict({ id: "Recipe:" + id });
        });
        cache.gc();
    },
});
//# sourceMappingURL=bulkDeleteRecipes.js.map